import gql from 'graphql-tag'

import { FRAGMENT_FOOTER, FRAGMENT_HEADER } from './shared.gql'

export const FRAGMENT_JSON_LD_ORGANIZATION = gql`
  fragment JsonLdOrganization on JsonLdOrganization {
    legalName
    name
    vatID
    logo
    email
    sameAs
    streetAddress
    addressLocality
    postalCode
    addressRegion
    addressCountry
  }
`

export const QUERY_BASE_DATA = gql`
  ${FRAGMENT_HEADER}
  ${FRAGMENT_FOOTER}
  ${FRAGMENT_JSON_LD_ORGANIZATION}

  query base($locale: LocaleInputType!) {
    Header(locale: $locale, draft: false) {
      ...Header
    }
    Footer(locale: $locale, draft: false) {
      ...Footer
    }

    JsonLdOrganization(locale: $locale) {
      ...JsonLdOrganization
    }

    # todo: we basically only need this to create correct links within richtexts.
    #  alternatively we could scan the richtexts on the api and provide the used relations only (similar to filter items)
    Publications(locale: $locale, limit: 0, draft: false, trash: false, where: { _status: { equals: published } }) {
      totalDocs
      docs {
        id
        slug
        title
      }
    }
    Projects(locale: $locale, limit: 0, draft: false, trash: false, where: { _status: { equals: published } }) {
      totalDocs
      docs {
        id
        slug
        title
      }
    }
    Pages(locale: $locale, limit: 0, draft: false, trash: false, where: { _status: { equals: published } }) {
      totalDocs
      docs {
        id
        slug
        title
      }
    }
  }
`
